module.exports = __webpack_public_path__ + "media/site_templates/www.plumbingservices.company/images/testimonials-50339e098e03499cfb2587ce5ad502bb.jpg";